import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => createStyles({
  labelRoot: {
    '& svg': {
      width: 16,
      height: 16,
      color: '#01B3C5 !important',
    },
    marginBottom: 8,
  },
  label: {
    fontSize: 16,
  },
  radioRoot: {
    padding: '3px 3px 3px 3px',
    marginLeft: 5,
    marginBottom: 2,
    '&:hover': {
      backgroundColor: 'rgba(0, 173, 141, 0.15) !important',
    },
  },
  radioRootWithDesc: {
    padding: 3,
    marginBottom: 2,
    marginRight: 5,
  },
  labelDescription: {
    fontSize: 12,
    color: '#5B6576',
    marginTop: -2,
    marginBottom: 14,
  },
  labelRootWithDesc: {
    alignItems: 'flex-start',
  },
  radioGroup: {

  },
  radioGroupHorizontal: {
    flexDirection: 'row',
  },
}), { name: 'FormRadioGroup' });

export default useStyles;
